import PricingEventsList from './PricingEventsList';
import './PricingEventsList.scss';

export default PricingEventsList;
